<template>
  <div>
    <sHeader :activeIndex="0"/>
    <div id="logo-demo">
      <div id="header-logo">
        <div class="border-logo">
          <div class="background-logo">
            <img class="header-logo-img" :src="headerLogoImage" alt="logo">
          </div>
        </div>
        <div class="background-pattern">
        </div>
        <div class="logo-inner-top-left-radius logo-inner-radius"></div>
        <div class="logo-inner-top-right-radius logo-inner-radius"></div>
        <div class="logo-inner-bottom-left-radius logo-inner-radius"></div>
        <div class="logo-inner-bottom-right-radius logo-inner-radius"></div>
        <div class="logo-outer-top-left-radius logo-outer-radius"></div>
        <div class="logo-outer-top-right-radius logo-outer-radius"></div>
        <div class="logo-outer-bottom-left-radius logo-outer-radius"></div>
        <div class="logo-outer-bottom-right-radius logo-outer-radius"></div>
      </div>
    </div>
    <div class="page-content container" id="home-page" v-if="portfolios">
      <div class="headline-wrapper">
        <div class="description-hatching"></div>
        <div class="description-box">
          <div class="portfolio-headline"><img :src="portfolioHeadlineImage"></div>
          <div class="top-left-radius dark-radius"></div>
          <div class="top-right-radius dark-radius"></div>
          <div class="bottom-left-radius dark-radius"></div>
          <div class="bottom-right-radius dark-radius"></div>
        </div>
      </div>

      <div class="portfolio-box" v-for="(portfolio, index) in portfolios" :key="index">
        <PortfolioItem :data="portfolio" />
      </div>
    </div>
  </div>
</template>

<script>
import sHeader from '@/components/templates/sHeader'
import PortfolioItem from '@/components/templates/PortfolioItem'

export default {
  components: {
    sHeader,
    PortfolioItem
  },
  mounted () {
    console.log('mounted')
    this.$ajax.get('interface.php?media=1&type=home')
      .then((res) => {
        console.log(res)
        this.portfolios = res.data.portfolios
        console.log(this.portfolios)
      })
  },
  methods: {
  },
  data () {
    return {
      portfolios: [],
      headerLogoImage: '//' + this.$mediaHost + '/naranzug/zvrag/naranzug.jpg',
      portfolioHeadlineImage: '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/svdvn_bolong.png'
    }
  }
}
</script>
<style>
#home-page {
  margin-top: 20px;
}
#logo-demo {
  text-align: center;
  background-color: #4bb5c1;
  height: 74px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue